// Tournament highlights on the index. Each card's Highlights button opens that
// year's standings and highlights in a dialog. Standings cost roughly 200
// queries per tournament, so a panel is fetched the first time it is opened
// and kept for reopening. Turbolinks, not Turbo.

const TournamentField = {
  cache: {},

  init() {
    const dialog = document.querySelector('[data-field-dialog]');
    if (!dialog || dialog.dataset.fieldReady === 'true') return;
    dialog.dataset.fieldReady = 'true';

    document.querySelectorAll('[data-field-open]').forEach((button) => {
      button.addEventListener('click', () => TournamentField.open(dialog, button));
    });

    dialog.querySelector('[data-field-dialog-close]').addEventListener('click', () => TournamentField.close(dialog));
    // A click on the backdrop (outside the panel) closes it.
    dialog.addEventListener('click', (event) => {
      if (event.target === dialog) TournamentField.close(dialog);
    });
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && !dialog.classList.contains('hidden')) TournamentField.close(dialog);
    });
  },

  open(dialog, button) {
    const body = dialog.querySelector('[data-field-dialog-body]');
    const url = button.dataset.fieldUrl;

    dialog.querySelector('[data-field-dialog-title]').textContent = button.dataset.fieldTitle;
    dialog.querySelector('[data-field-dialog-link]').setAttribute('href', button.dataset.fieldLink);
    dialog.classList.remove('hidden');
    document.body.classList.add('overflow-hidden');
    dialog.querySelector('[data-field-dialog-close]').focus();

    if (TournamentField.cache[url]) {
      body.innerHTML = TournamentField.cache[url];
      return;
    }

    body.innerHTML = '<div class="faso-expand-panel faso-caption">Loading highlights…</div>';
    fetch(url, { headers: { 'Accept': 'text/html' }, credentials: 'same-origin' })
      .then((response) => {
        if (!response.ok) throw new Error(`HTTP ${response.status}`);
        return response.text();
      })
      .then((html) => {
        TournamentField.cache[url] = html;
        // Only if this year is still the one showing.
        if (dialog.querySelector('[data-field-dialog-link]').getAttribute('href') === button.dataset.fieldLink) {
          body.innerHTML = html;
        }
      })
      .catch(() => {
        body.innerHTML = '<div class="faso-expand-panel faso-caption">Could not load the highlights for this tournament.</div>';
      });
  },

  close(dialog) {
    dialog.classList.add('hidden');
    document.body.classList.remove('overflow-hidden');
  }
};

document.addEventListener('turbolinks:load', TournamentField.init);

// Turbolinks caches the page as it is: close the dialog first, and clear the
// ready flag, since the restored copy has none of the listeners.
document.addEventListener('turbolinks:before-cache', () => {
  const dialog = document.querySelector('[data-field-dialog]');
  if (!dialog) return;
  TournamentField.close(dialog);
  delete dialog.dataset.fieldReady;
});

export default TournamentField;
